import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ErrorLabel from "../../../../component/error_label";

import { useNavigate } from "react-router-dom";
import { actionForgotPasswordAdminSendOtp, actionForgotPasswordAdminVerifyOtp, resetForgotPasswordAdminSendOtpResponse, resetForgotPasswordAdminVerifyOtpResponse } from "../store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../common/app_constant";
import toast from "react-hot-toast";
import { getNextScreen } from "../../../../utils";
import { jwtDecode } from "jwt-decode";

const ForgotPasswordAdmin = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [screenMode, setscreenMode] = useState("sendotp");
  const [otp, setOTP] = useState();
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");  // State variable to store email
  const [timer, setTimer] = useState(60); // Initial timer value in seconds
  const [isTimerRunning, setIsTimerRunning] = useState(true);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  //START forgotpswd Admin - api SEND(get) OTP- response
  const { forgotPasswordAdminSendOtp } = useSelector(state => ({
    ...state.publicStore,
  }));

  const { forgotPasswordAdminVerifyOtp }  = useSelector(state => ({
    ...state.publicStore,
  }))
  // END

  // Get OTP Button CLICK
  const onForgotPswdSendOtpSubmit = data => {
    setEmail(data.email); //Store the email in state
    dispatch(actionForgotPasswordAdminSendOtp(data));

  };
  // END

  // Verify Buttton Click
  const onVerifyForgotPswdAdminOTP = (data) => {
    dispatch(actionForgotPasswordAdminVerifyOtp(data));
  };
  // END

  // api call on update ---- > when response is true
  // setGetOTP(true)

  // Timer START

useEffect(() => {
  let countdown; // variable to hold the countdown interval

  // Function to document the timer every second
  const startTimer = () => {
    countdown = setInterval(() => {
      setTimer((prevTimer) => {
          if (prevTimer === 0) {
              clearInterval(countdown); // Stop the countdown when timer reaches 0
              setIsTimerRunning(false);
              return 60;  // Reset timer to initial value
          }
          return prevTimer -1; // Decrement timer by 1 second
      });
    }, 1000);
  };

  // Start the timer when isTimerRunning becomes true
  if (isTimerRunning) {
    startTimer();
  } else {
    clearInterval(countdown); // Clear interval if timer is not running
  }

  // Clean up function to clear the interval when component unmounts or when timer stops
  return () => clearInterval(countdown);
}, [isTimerRunning]);
  
// Timer END
  useEffect(() => {
    console.log("Forgot Password Send OTP Response:", forgotPasswordAdminSendOtp);
    if (forgotPasswordAdminSendOtp !== null) {
      dispatch(resetForgotPasswordAdminSendOtpResponse());
      if (forgotPasswordAdminSendOtp?.status === true) {
        setIsTimerRunning(true);
        setscreenMode("verifyotp");
        toast.success(forgotPasswordAdminSendOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      } else {
        toast.error(forgotPasswordAdminSendOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      }
    }
  }, [forgotPasswordAdminSendOtp]);



  useEffect(() => {
    console.log("Forgot Password Verify OTP Response:", forgotPasswordAdminVerifyOtp);
    // Rest of your code
    // if (forgotPasswordAdminVerifyOtp !== null) {
      if (forgotPasswordAdminVerifyOtp !== null){
     dispatch(resetForgotPasswordAdminVerifyOtpResponse());
     if (forgotPasswordAdminVerifyOtp?.status===true) {
      localStorage.setItem("userData", JSON.stringify(forgotPasswordAdminVerifyOtp.data.userData));
       localStorage.setItem("token", JSON.stringify(forgotPasswordAdminVerifyOtp.data.token));
        const decoded = jwtDecode(forgotPasswordAdminVerifyOtp?.data?.token);
        getNextScreen(decoded?.role)
      //  alert(JSON.stringify(forgotPasswordAdminVerifyOtp.data.next))
       navigate("/admin-change-password");
         window.location.reload();
           // alert("hello",getVerifyLoginOtp?.data?.is_verified )
     }else{
       toast.error(forgotPasswordAdminVerifyOtp?.message, {
         duration: TOAST_DURATION,
         position: TOAST_POSITION,
         style: {},
       });
     }
    }
   },[forgotPasswordAdminVerifyOtp])
  return (
    <>
    <div className="container">
      <div className="row justify-content-center ">
        <div className="col-md-4 align-item-center mt-6">
          <div className="card">
            <div className="card-body">
              <p className="lead fw-bold text-secondary">
                <span className="text-dark">Forgot Password</span>
              </p>
              {/* Enter Email For Forgot Passowrd  */}
              {screenMode === "sendotp" && (
              <div>
                <form onSubmit={handleSubmit(onForgotPswdSendOtpSubmit)}>
                  <div class="form-group mb-2">
                    <label className="form-label" htmlFor="email">
                      Email ID
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className="form-control form-control-lg"
                      placeholder="Enter a valid email id"
                      {...register("email", {
                        required: "This is required.",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "invalid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <ErrorLabel message={errors.email?.message} />
                    )}
                  </div>

                  <button type="submit" className="btn btn-primary w-100">
                    Get OTP
                  </button>
                </form>
              </div>
              )}

              {/* Enter OTP  and verify for  forgot password */}
              {screenMode === "verifyotp" && (
              <div>
                <form
                  noValidate
                  autoComplete="off"
                  onSubmit={handleSubmit(onVerifyForgotPswdAdminOTP)}
                >
                  <p className="lead fw-bold me-3 text-secondary mb-1">
                    <span className="text-dark h6">
                        OTP is sent to your Mobile Number
                    </span>
                  </p>
                  <div className="form-outline mb-3 mt-4">
                    <label className="form-label" htmlFor="otp">
                      Enter OTP
                    </label>
                    <div className="">
                      <input
                        className="form-control form-control-lg"
                        type="text"
                        id="otp"
                        name="otp"
                        value={otp}
                        onChange={event => setOTP(event.target.value)}
                        {...register("otp", {
                          required: "This is required.",
                        })}
                      />
                      {errors.otp && (
                        <ErrorLabel message={errors.otp?.message} />
                      )}
                      <input type="hidden" name="code" value="axis"></input>
                    </div>
                    {error && <p>{error}</p>}
                  </div>
                  <div>
                      <div className="text-center text-primary">
                          {!isTimerRunning && (
                              <a onClick={() => dispatch(actionForgotPasswordAdminSendOtp({ email }))}> Resend OTP </a>
                          )}
                          {isTimerRunning && <p>Resend OTP in {timer} secconds</p>}
                      </div>
                  </div>
                  <div className="text-center text-lg-start mt-4">
                    <button type="submit" className="btn btn-primary w-100">
                      Verify OTP
                    </button>
                  </div>
                </form>
              </div> 
              )
                      }
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default ForgotPasswordAdmin;
